import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/vfm/NewDesignModal.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import DailyMotionPlayer from '@/ui-components/players/DailyMotionPlayer.vue';
import { isBitMovinCountry } from '@/helpers/trailer-helper';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { isProWebCountry } from '@/helpers/pro-web-helper';

export default /*#__PURE__*/_defineComponent({
  __name: 'JwTVModal',
  props: {
    offer: null,
    title: { default: undefined },
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as { offer: Offer, title: TitleDetail, additionalContexts?: SnowplowContext[] };

const JWTVProFooter = () => import('@/pages/titleDetailV1/v1/hero/JWTVProFooter.vue');


const { isPremium } = storeToRefs(useUserStore());
const { country, webLocale } = storeToRefs(useLanguageStore());

const showJWTVProFooter = computed(() => {
	return !isPremium.value && isProWebCountry(webLocale.value);
});

const titleName = computed(() =>
	props.title?.__typename == 'Season' ? props.title?.show?.content.title : props.title?.content.title
);

const clip = computed(() => ({
	provider: 'JUSTWATCH_TV',
	externalId: props.offer.id,
	sourceUrl: isBitMovinCountry(country.value)
		? props.offer.streamUrlExternalPlayer ?? props.offer.streamUrl
		: props.offer.streamUrl,
}));

return { __sfc: true,JWTVProFooter, props, isPremium, country, webLocale, showJWTVProFooter, titleName, clip, NewDesignModal, DailyMotionPlayer }
}

})